import {useListView} from '../../core/ListViewProvider'
import {ManagersListToolbar} from './ManagersListToolbar'
import {ManagersListGrouping} from './ManagersListGrouping'
import {ManagersSearchComponent} from './ManagersSearchComponent'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddManager?: boolean
}

const ManagersListHeader = ({showAddManager = true}: PropTypes) => {
  const {selected} = useListView()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: TOKENS.spacing.md,
        padding: '14px 18px',
        borderBottom: `1px solid ${TOKENS.color.border}`,
        background: TOKENS.color.card,
      }}
    >
      <ManagersSearchComponent />
      <div>
        {selected.length > 0 ? <ManagersListGrouping /> : <ManagersListToolbar showAddManager={showAddManager} />}
      </div>
    </div>
  )
}

export {ManagersListHeader}
